import * as RUBYPLAY_ERRORS_MESSAGES from '@gongxigames/framework/slot/configs/messages';
import {Message} from '@gongxigames/framework/slot/types';
import {ICheatPluginController, ICheatsModule} from '../../CheatModuleInterfaces';

export class CheatErrorsController implements ICheatPluginController {
    protected _errors!: any[];
    protected _module!: ICheatsModule;

    public init(module: ICheatsModule): void {
        this._module = module;
        this._errors = Object.entries(RUBYPLAY_ERRORS_MESSAGES);
    }

    public show(error: Message): void {
        this._module.eventManager.emit('General.Message.CLOSE');
        this._module.eventManager.emit('General.Message.SHOW', error);
    }

    public close(): void {
        this._module.eventManager.emit('General.Message.CLOSE');
    }

    public get errors(): any[] {
        return this._errors;
    }
}
